/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { withRouter } from "../../_shared/withRouter";
import { useTranslation } from "react-i18next";
import HeadingComponent from "./headingComponent";
import {
  userSelfRegister,
  userLevelProgressApi,
  userRegisterVerifyNumber,
  userRegisterNumber,
  userCheckDob,
  fetchUserProfileApi,
  userPreRegister,
} from "../../user/_userActions";
import { GENDER_LIST, GLOBAL_API } from "../../actionTypes/types";
import DatePicker from "react-date-picker";
import { globalLoader, globalAlert } from "../../actions/commonActions";
import TimerComp from "../../_shared/timer";
import TermsComponent from "./termsComponent";
import RegSuccessModal from "./regSuccessModal";
import InputComponent from "./inputComponent";
import { validPostCodeFunc } from "../../_shared/commonFunction";
import { Box, Checkbox, FormControlLabel } from "@mui/material";
import TermsModal from "../auth/termsModal";
import LanguageSelector from "./languageSelector";
import { withNativeNames } from "../../i18n/languages";
import { getRequest } from "../../actionTypes/axiosUtility";

const RegisterComponent = (props) => {
  const { t } = useTranslation();
  const [values, setValues] = useState({
    phone: "",
    postCode: "",
    birthDate: new Date("fake date"),
    gender: "",
  });
  const [emptyMobile, setEmptyMobile] = useState(false);
  const [postalcode, setPostalcode] = useState("");
  const [emptyPostalCode, setEmptyPostalCode] = useState(false);
  const [dob, setDob] = useState(null);
  const [emptyDob, setEmptyDob] = useState(false);
  const [genderMsg, setGenderMsg] = useState("");
  const [accessCodeRequired, setAccessCodeRequired] = useState(false);
  const [showUnlimitedTransaction, setShowUnlimitedTransaction] =
    useState(false);
  const [accessCode, setAccessCode] = useState("");
  const [emptyAccessCode, setEmptyAccessCode] = useState(false);
  const [toggleOtp, setToggleOtp] = useState(false);
  const [otp, setOtp] = useState("");
  const [emptyOtp, setEmptyOtp] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [termsAccept, setTermsAccept] = useState(false);
  const [openRegSuccessModal, setOpenRegSuccessModal] = useState();
  const [regSuccessMsg, setRegSuccessMsg] = useState(``);
  const [phoneVerify, setPhoneVerify] = useState(false);
  const [warningMsg, setWarningMsg] = useState("");
  const [height, setHeight] = useState(0);
  const [validPostcodeVal, setValidPostcodeVal] = useState(false);
  const [allowedTransactionLimit, setAllowedTransactionLimit] = useState(0);
  const [isUnlimitedTransaction, setIsUnlimitedTransaction] = useState(false);
  const [whatWeDoWithDataModal, setWhatWeDoWithDataModal] = useState(false);
  const [whatWeDoWithDataText, setWhatWeDoWithDataText] = useState("");
  const [preferredLanguage, setPreferredLanguage] = useState(
    localStorage.getItem("userLanguage") || "en"
  );
  const [orgLanguages, setOrgLanguages] = useState([]);
  const [languageSelected, setLanguageSelected] = useState(false);
  const [languagesLoading, setLanguagesLoading] = useState(true);

  useEffect(() => {
    // TEMPORARY: Registration must expose the complete public language list
    // because the user's organisation is not known at this stage.
    // FUTURE: Once organisation resolution is available before this screen,
    // apply ORGANIZATION_LANGUAGE_CONTROL_ENABLED here as well.
    const fetchLanguages = async () => {
      try {
        const res = await getRequest(
          `${GLOBAL_API}/translations/public/v1/supported-languages`
        );
        if (res?.data?.status === 200 && res?.data?.data?.languages) {
          setOrgLanguages(res.data.data.languages);
        }
      } catch (err) {
        // Silently fail -- language selector will show default English
      } finally {
        setLanguagesLoading(false);
      }
    };
    fetchLanguages();
  }, []);

  useEffect(() => {
    if (dob && postalcode) {
      checkDob();
    }
  }, [dob, postalcode]);

  const checkDob = async () => {
    try {
      globalLoader(true);
      let obj = {
        dateOfBirth: dob,
        postalCode: postalcode,
      };
      let res = await userCheckDob(obj);
      if (res?.data?.status === 200) {
        setAccessCodeRequired(res?.data?.data?.accessCodeRequired);
        if (res?.data?.data?.accessCodeRequired) {
          setShowUnlimitedTransaction(res?.data?.data?.showUnlimitedOption);
        }
        if (res?.data?.data?.warning?.show) {
          setWarningMsg(res?.data?.data?.warning?.message);
        } else {
          setWarningMsg(``);
        }
      } else {
        setWarningMsg("");
      }

      globalLoader(false);
    } catch (err) {
      globalAlert("error", err?.response?.data?.message);
      globalLoader(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };

  const handleValidation = (value = null) => {
    const { phone, gender } = values;
    let isValid = true;
    if (!phone) {
      setEmptyMobile(true);
      isValid = false;
    } else if (phone.length < 10) {
      isValid = false;
    }
    if (!toggleOtp && phoneVerify) {
      if (!postalcode) {
        setEmptyPostalCode(true);
        isValid = false;
      }
      if (!validPostcodeVal) {
        isValid = false;
      }
      if (!dob) {
        setEmptyDob(true);
        isValid = false;
      }
      if (!gender) {
        setGenderMsg(t("user.register.genderRequired"));
        isValid = false;
      }
      if (accessCodeRequired && !accessCode) {
        setEmptyAccessCode(true);
        isValid = false;
      }
    }

    if (toggleOtp && !value && !otp) {
      setEmptyOtp(true);
      isValid = false;
    }
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (await handleValidation()) {
      globalLoader(true);

      if (phoneVerify) {
        const resp = await userPreRegister({ postalCode: postalcode?.replace(/\s+/g, "") })
        if(resp?.data?.status === 200 && resp?.data?.data?.preMessage?.length > 0){
          setWhatWeDoWithDataText(resp?.data?.data?.preMessage);
          setWhatWeDoWithDataModal(true);
        } else {
          await handleFullRegisterApiSubmit();
        }
        globalLoader(false);
      } else if (toggleOtp) {
        let obj = {
          mobile: values.phone,
          otp: otp,
        };

        let res = await userRegisterVerifyNumber(obj);
        if (res?.data?.status === 200) {
          globalAlert("success", res?.data?.message);
          globalLoader(false);
          setPhoneVerify(true);
          setToggleOtp(false);
        } else {
          globalAlert("error", res?.data?.message);
          globalLoader(false);
        }
      } else {
        let obj = {
          mobile: values.phone,
        };

        let res = await userRegisterNumber(obj);
        if (res?.data?.status === 200) {
          globalAlert("success", res?.data?.message);
          globalLoader(false);
          setToggleOtp(true);
        } else {
          globalAlert("error", res?.data?.message);
          globalLoader(false);
        }
      }
    }
  };

  const handleFullRegisterApiSubmit = async () => {
    globalLoader(true);
    let obj = {
      mobile: values.phone,
      postalCode: postalcode.replace(/\s+/g, ""),
      dateOfBirth: dob,
      gender: values.gender,
      accessCode: accessCode ? accessCode : null,
      allowedTransactionLimit:
        isUnlimitedTransaction && showUnlimitedTransaction
          ? -1
          : parseInt(allowedTransactionLimit),
      preferredLanguage: preferredLanguage,
    };
    let res = await userSelfRegister(obj);
    if (res?.data?.status === 200) {
      setRegSuccessMsg(res?.data?.message);
      setOpenRegSuccessModal(true);
    } else {
      globalAlert("error", res?.data?.message);
    }

    globalLoader(false);
  };  

  const onCloseRegSuccessModal = async () => {
    setOpenRegSuccessModal(false);
    const userProfileApi = await fetchUserProfileApi();
    if (userProfileApi?.data?.status === 200 && userProfileApi?.data?.data?.questions?.show) {
      props.history.push(`/${props.roleType}/missing-profile`);
    } else {
      let progress = await userLevelProgressApi();
      if (progress?.data?.status === 200) {
        if (!progress?.data?.data?.skipVideosPage) {
          props.history.push(`/${props.roleType}/video`);
        } else if (
          progress?.data?.data?.skipVideosPage &&
          !progress?.data?.data?.skipQuizPage
        ) {
          props.history.push(`/${props.roleType}/quiz`);
        } else if (progress?.data?.data?.quizLevelPassed) {
          props.history.push(`/${props.roleType}/dashboard`);
        } else {
          props.history.push(`/${props.roleType}/video`);
        }
      } else {
        globalAlert("error", progress?.data?.message);
        window.location.reload();
      }
    }
  };

  const handleOtp = async () => {
    if (await handleValidation(true)) {
      globalLoader(true);
      let res = await userRegisterNumber({ mobile: values?.phone });
      if (res?.data?.status === 200) {
        globalAlert("success", res?.data?.message);
        setOtpSent(false);
        setEmptyOtp(false);
      } else {
        globalAlert("error", res?.data?.message);
      }
      globalLoader(false);
    }
  };

  const handlePostalCode = async (ev) => {
    // let data = ev?.target?.value;
    let data = ev;
    if (data.length < 8) {
      let value = data.split(" ").join("");
      setPostalcode(value);
      setValidPostcodeVal(await validPostCodeFunc(value));
    }
  };

  const setTimerOver = () => {
    setOtpSent(true);
  };

  const handleTransactionLimit = (val) => {
    const positiveIntegerPattern = /^[0-9]*$/;
    if (val === "" || positiveIntegerPattern.test(val)) {
      setAllowedTransactionLimit(val);
    }
  };

  const handleCheckboxChange = (e) => {
    const { checked } = e.target;
    if (checked) {
      setAllowedTransactionLimit(0);
    }
    setIsUnlimitedTransaction(checked);
  };

  const onWhatWeDoWithDataModalClose = async (flag = false) => {
    if (flag) {
      await handleFullRegisterApiSubmit();
    }
    setWhatWeDoWithDataModal(false);
  };

  const genderTextMap = {
    male: t("user.register.genderMale"),
    female: t("user.register.genderFemale"),
    "non-binary": t("user.register.genderNonBinary"),
    others: t("user.register.genderOther"),
    not_disclosed: t("user.register.genderNotDisclosed"),
  };

  return (
    <>
      <div>
        {languagesLoading ? (
          <div className="text-center py-5">
            <div className="spinner-border" role="status">
              <span className="sr-only">{t("common.loading")}</span>
            </div>
          </div>
        ) : orgLanguages.length > 1 && !languageSelected ? (
          <div>
            <HeadingComponent text={t("user.register.selectLanguageHeading")} getHeight={(ev) => setHeight(ev)} />
            <div
              className="reg-screen-wrapper pt-4"
              style={{
                marginTop: `${height}px`,
                minHeight: `calc(100vh - ${height}px)`,
              }}
            >
              <div className="fix-width-wrapper px-3 mx-auto">
                <div className="form-group">
                  <p className="mb-3">{t("user.register.selectLanguagePrompt")}</p>
                  <LanguageSelector
                    languages={withNativeNames(orgLanguages)}
                    value={preferredLanguage}
                    onChange={(lang) => setPreferredLanguage(lang)}
                    label={t("user.register.languageLabel")}
                  />
                </div>
                <div className="form-group mt-3 pt-2">
                  <button
                    className="btnFooter w-100 d-block"
                    onClick={() => setLanguageSelected(true)}
                  >
                    {t("user.register.continueButton")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : termsAccept ? (
          <div>
            <HeadingComponent text={t("user.register.title")} getHeight={(ev) => setHeight(ev)} />

            <div
              className="reg-screen-wrapper pt-4"
              style={{
                marginTop: `${height}px`,
                minHeight: `calc(100vh - ${height}px)`,
              }}
            >
              <div className="fix-width-wrapper px-3 mx-auto">
                <form className="form-own" onSubmit={handleSubmit}>
                  {!toggleOtp && (
                    <>
                      {!phoneVerify && (
                        <div className="form-group">
                          <p>
                            {t("user.register.verifyMobileText")}
                          </p>
                          <p>
                            {t("user.register.enterMobileText")}
                          </p>
                        </div>
                      )}
                      <div className="form-group">
                        <InputComponent
                          placeholder={t("user.register.mobilePlaceholder")}
                          label={`${t("user.register.mobileLabel")} *`}
                          type="text"
                          name="phone"
                          inputFor="number"
                          theme="white"
                          maxLength="11"
                          value={values?.phone}
                          disabled={phoneVerify ? true : false}
                          autoComplete="off"
                          handleCallback={
                            phoneVerify
                              ? null
                              : (val) => {
                                  const name = "phone";
                                  setValues({ ...values, [name]: val });
                                }
                          }
                        />
                        <div className="error-text">
                          {!values?.phone && emptyMobile && (
                            <span>{t("user.register.mobileRequired")}</span>
                          )}
                          {values?.phone && values?.phone?.length < 10 && (
                            <span>{t("user.register.mobileMinDigits")}</span>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  {phoneVerify && (
                    <>
                      <div className="form-group">
                        <InputComponent
                          placeholder={t("user.register.postcodeLabel")}
                          label={t("user.register.postcodeLabel")}
                          type="text"
                          name="postCode"
                          inputFor="text"
                          theme="white"
                          value={postalcode}
                          autoComplete="off"
                          handleCallback={(val) => handlePostalCode(val)}
                          capsValue={true}
                        />
                        <div className="error-text">
                          {!postalcode && emptyPostalCode && (
                            <span>{t("user.register.postcodeRequired")}</span>
                          )}
                          {postalcode && !validPostcodeVal && (
                            <span>{t("user.register.postcodeInvalid")}</span>
                          )}
                        </div>
                      </div>
                      <div className="form-group form-group-lg position-relative">
                        <label className="datepicker-label" htmlFor="birthDate">
                          {t("user.register.dobLabel")}
                        </label>
                        <div className="own-datepicker">
                          <DatePicker
                            id="birthDate"
                            onChange={setDob}
                            value={dob}
                            maxDate={new Date()}
                            format={"dd/MM/yyy"}
                             calendarAriaLabel="Open calendar"
                          />
                        </div>
                        <div className="error-text">
                          {!dob && emptyDob && (
                            <span>{t("user.register.dobRequired")}</span>
                          )}
                        </div>
                      </div>

                      {warningMsg && (
                        <div className="text-danger py-3 font-12">
                          {warningMsg}
                        </div>
                      )}

                      {accessCodeRequired && (
                        <>
                          <div className="form-group form-group-lg">
                            <InputComponent
                              placeholder={t("user.register.accessCodeLabel")}
                              label={t("user.register.accessCodeLabel")}
                              type="text"
                              name="accessCode"
                              inputFor="text"
                              theme="white"
                              value={accessCode}
                              autoComplete="off"
                              maxLength={6}
                              handleCallback={(val) => setAccessCode(val)}
                            />
                            <div className="error-text">
                              {!accessCode && emptyAccessCode && (
                                <span>{t("user.register.accessCodeRequired")}</span>
                              )}
                              {accessCode && accessCode?.length < 5 && (
                                <span>{t("user.register.accessCodeMinDigits")}</span>
                              )}
                            </div>
                          </div>
                          <Box
                            display={{ xs: "flex" }}
                            flexDirection={{ xs: "row" }}
                            justifyContent={{ xs: "space-between" }}
                            alignItems={{ xs: "center" }}
                          >
                            <div className="form-group form-group-lg mr-2">
                              <InputComponent
                                disabled={isUnlimitedTransaction}
                                placeholder={t("user.register.transactionLimit")}
                                label={t("user.register.transactionLimit")}
                                type="number"
                                name="allowedTransactionLimit"
                                inputFor="text"
                                theme="white"
                                value={allowedTransactionLimit}
                                autoComplete="off"
                                maxLength={3}
                                handleCallback={(val) =>
                                  handleTransactionLimit(val)
                                }
                              />
                            </div>
                            {showUnlimitedTransaction && (
                              <div className="form-group form-group-lg ml-2">
                                <FormControlLabel
                                  label={t("user.register.unlimitedTransactions")}
                                  control={
                                    <Checkbox
                                      size="small"
                                      checked={isUnlimitedTransaction}
                                      onChange={handleCheckboxChange}
                                    />
                                  }
                                />
                              </div>
                            )}
                          </Box>
                        </>
                      )}

                      <div className="form-group gender-form-group">
  {/* ✅ CHANGED: Removed htmlFor="gender" because there is
      no input with id="gender" */}
  <fieldset className="gender-fieldset">
    {/* ✅ CHANGED: legend labels the complete radio group */}
    <legend className="reg-text">
      {t("user.register.genderLabel")}
    </legend>

    <div className="radio-wrapper">
      {GENDER_LIST.map((i) => {
        return (
          <div key={i.id} className="radio">
            <input
              id={i.id}
              className="hidden radio-label"
              type="radio"
              value={i.value}
              name="gender"
              checked={values.gender === i.value}
              onChange={handleInputChange}
              autoComplete="off"
            />

            <label className="btn-label" htmlFor={i.id}>
              <p>{genderTextMap[i.value] || t(i.text)}</p>
            </label>
          </div>
        );
      })}
    </div>
  </fieldset>

  <div className="error-text">
    {!values.gender && genderMsg && (
      <span>{genderMsg}</span>
    )}
  </div>
</div>
                    </>
                  )}

                  {toggleOtp && (
                    <>
                      <div className="form-group pt-3">
                        <p>{t("user.register.otpSentText")}</p>
                        <div className="form-group">
                          <InputComponent
                            placeholder={t("user.register.mobilePlaceholder")}
                            label={`${t("user.register.mobileLabel")} *`}
                            type="text"
                            name="phone"
                            inputFor="number"
                            theme="white"
                            maxLength="11"
                            value={values?.phone}
                            disabled={true}
                            autoComplete="off"
                            handleCallback={null}
                          />
                        </div>
                      </div>
                      <div className="form-group">
                        <InputComponent
                          placeholder={t("user.register.otpLabel")}
                          label={`${t("user.register.otpLabel")} *`}
                          type="text"
                          name="otp"
                          inputFor="number"
                          theme="white"
                          maxLength="6"
                          value={otp}
                          autoComplete="off"
                          handleCallback={(val) => {
                            setOtp(val.replace(/\D/g, "").slice(0, 6));
                          }}
                        />
                        <div className="error-text font-12 pl-2">
                          {!otp && emptyOtp && <span>{t("user.register.otpRequired")}</span>}
                        </div>
                      </div>

                      <div className="resend-otp-txt text-center mb-3 mt-3">
                        {!otpSent ? (
                          <TimerComp setTimerOver={setTimerOver} />
                        ) : (
                          <span className="cursor" onClick={handleOtp}>
                            {t("user.register.resendOtp")}
                          </span>
                        )}
                      </div>
                    </>
                  )}
                  <div className="form-group mt-3 pt-2">
                    {phoneVerify ? (
                      <div className="reg-btn-wrapper">
                        <button
                          type="button"
                          className="text-dark"
                          onClick={() => {
                            setPhoneVerify(false);
                            setToggleOtp(false);
                            setOtp("");
                            setEmptyOtp(false);
                            setPostalcode("");
                            setEmptyPostalCode(false);
                            setDob(null);
                            setEmptyDob(false);
                            setGenderMsg("");
                            setValues({
                              phone: "",
                              postCode: "",
                              birthDate: new Date("fake date"),
                              gender: "",
                            });
                          }}
                        >
                          {t("user.register.cancelButton")}
                        </button>
                        <button type="submit" className="text-dark">
                          {t("user.register.saveDetails")}
                        </button>
                      </div>
                    ) : (
                      <button type="submit" className="btnFooter w-100 d-block">
                        {!toggleOtp && !phoneVerify
                          ? t("user.register.submitButton")
                          : toggleOtp
                          ? t("user.register.submitButton")
                          : ""}
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        ) : (
          <TermsComponent accept={() => setTermsAccept(true)} />
        )}
        {openRegSuccessModal && (
          <RegSuccessModal
            open={openRegSuccessModal}
            message={regSuccessMsg}
            closeModal={onCloseRegSuccessModal}
          />
        )}
      </div>
      {(whatWeDoWithDataModal && whatWeDoWithDataText?.length > 0) && (
        <TermsModal
          open={whatWeDoWithDataModal}
          onCloseModal={onWhatWeDoWithDataModalClose}
          heading={t("user.register.whatWeDoWithData")}
          body={whatWeDoWithDataText}
        />
      )}
    </>
  );
};

export default withRouter(RegisterComponent);
